import {JIS_X0208_TABLE} from './jisx0208table'

/**
 * 文字列をコードポイントの配列に変換する
 */
export const stringToCode = str => {
  const code = [];
  const len = str && str.length;
  for (let i = 0; i < len; i++) {
    code.push(str.charCodeAt(i));
  }
  return code;
};

/**
 * UnicodeのコードポイントをUTF8のコードポイントに変換する
 */
export const unicodeToUtf8 = data => {
  const results = [];
  let i = 0;
  const len = data && data.length;
  let c, second;

  for (; i < len; i++) {
    c = data[i];

    // high surrogate
    if (c >= 0xD800 && c <= 0xDBFF && i + 1 < len) {
      second = data[i + 1];
      // low surrogate
      if (second >= 0xDC00 && second <= 0xDFFF) {
        c = (c - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        i++;
      }
    }

    if (c < 0x80) {
      results.push(c);
    } else if (c < 0x800) {
      results.push(0xC0 | ((c >> 6) & 0x1F));
      results.push(0x80 | (c & 0x3F));
    } else if (c < 0x10000) {
      results.push(0xE0 | ((c >> 12) & 0xF));
      results.push(0x80 | ((c >> 6) & 0x3F));
      results.push(0x80 | (c & 0x3F));
    } else if (c < 0x200000) {
      results.push(0xF0 | ((c >> 18) & 0xF));
      results.push(0x80 | ((c >> 12) & 0x3F));
      results.push(0x80 | ((c >> 6) & 0x3F));
      results.push(0x80 | (c & 0x3F));
    }
  }

  return results;
};

/**
 * UTF8のコードポイントをEUC-JPのコードポイントに変換する
 * 対応するEUC-JPのコードポイントが存在しない場合nullを返却する
 * EUC-JPはAsciiとJIS X0208（日本語の基本的な文字集合）に対応する
 * （JIS X0201（半角カナ）JIS X0212（JIS補助漢字）には対応しない）
 */
export const utf8ToEucJp = data => {
  const results = [];
  let i = 0;
  const len = data && data.length;
  let b, utf8, jis;

  for (; i < len; i++) {
    b = data[i];
    if (b >= 0x80) {
      if (b <= 0xDF) {
        // 2 bytes
        utf8 = (b << 8) + data[++i];
      } else if (b <= 0xEF) {
        // 3 bytes
        utf8 = (b << 16) +
          (data[++i] << 8) +
          (data[++i] & 0xFF);
      } else {
        // 4 bytes
        utf8 = (b << 24) +
          (data[++i] << 16) +
          (data[++i] << 8) +
          (data[++i] & 0xFF);
      }

      jis = JIS_X0208_TABLE[utf8];
      if (jis == null) {
        return null;
        // jis = JIS_X0212_TABLE[utf8];
        // if (jis == null) {
        //   return null;
        // } else {
        //   results[results.length] = 0x8F;
        //   results[results.length] = (jis >> 8) - 0x80 & 0xFF;
        //   results[results.length] = (jis & 0xFF) - 0x80 & 0xFF;
        // }
      } else {
        if (jis > 0x10000) {
          jis -= 0x10000;
        }
        if (jis < 0xFF) {
          results[results.length] = 0x8E;
          results[results.length] = jis - 0x80 & 0xFF;
        } else {
          results[results.length] = (jis >> 8) - 0x80 & 0xFF;
          results[results.length] = (jis & 0xFF) - 0x80 & 0xFF;
        }
      }
    } else {
      results[results.length] = data[i] & 0xFF;
    }
  }
  return results;
};